import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_DISTRIBUTORS_QUERY = queryWithFallbackKey(
    gql`
        query getDistributorsListing($defaultLanguage: String!) {
            getObjectFolder(fullpath: "/Contacts/Distributors", defaultLanguage: $defaultLanguage) {
                children {
                    ... on object_Distributor {
                        id
                        key
                        name
                        isGlobal
                        isFeatured
                        url
                        phone
                        logo {
                            fullpath
                        }
                        countries {
                            ... on object_Country {
                                id
                            }
                        }
                        text
                    }
                }
            }
        }
    `,
    'GET_DISTRIBUTORS_QUERY'
);

export function getDistributorsQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
